/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';
import type { SchemeEmployerModel } from './SchemeEmployerModel';
import {
    SchemeEmployerModelFromJSON,
    SchemeEmployerModelFromJSONTyped,
    SchemeEmployerModelToJSON,
} from './SchemeEmployerModel';

/**
 * 
 * @export
 * @interface ResultOfSchemeEmployerModel
 */
export interface ResultOfSchemeEmployerModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfSchemeEmployerModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfSchemeEmployerModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfSchemeEmployerModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfSchemeEmployerModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfSchemeEmployerModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfSchemeEmployerModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfSchemeEmployerModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {SchemeEmployerModel}
     * @memberof ResultOfSchemeEmployerModel
     */
    data?: SchemeEmployerModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfSchemeEmployerModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfSchemeEmployerModel interface.
 */
export function instanceOfResultOfSchemeEmployerModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfSchemeEmployerModelFromJSON(json: any): ResultOfSchemeEmployerModel {
    return ResultOfSchemeEmployerModelFromJSONTyped(json, false);
}

export function ResultOfSchemeEmployerModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfSchemeEmployerModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : SchemeEmployerModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfSchemeEmployerModelToJSON(value?: ResultOfSchemeEmployerModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': SchemeEmployerModelToJSON(value.data),
        'Count': value.count,
    };
}

